var _path, _path2, _circle, _path3, _path4, _circle2, _ellipse, _ellipse2, _g, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeKeynote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 59.5745L114.092 69.193L116.396 80.2663L107.571 87.2569L105.963 98.4539L95.3001 101.985L90.0055 111.962L78.7882 111.612L70.4186 119.149L60.0003 114.935L49.5814 119.149L41.2118 111.612L29.9938 111.962L24.6999 101.985L14.0365 98.4539L12.4293 87.2563L3.6036 80.2663L5.90754 69.193L0 59.5745L5.90754 49.9553L3.6036 38.882L12.4293 31.892L14.0371 20.6944L24.6999 17.163L29.9944 7.18651L41.2118 7.53741L49.5814 0L60.0003 4.21342L70.4186 0L78.7882 7.53741L90.0062 7.18651L95.3001 17.1636L105.964 20.6951L107.571 31.892L116.396 38.8826L114.092 49.9553L120 59.5745Z",
    fill: "#52A73E",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9961 108.142C86.6017 108.142 108.17 86.3997 108.17 59.5797C108.17 32.7597 86.6017 11.0178 59.9961 11.0178C33.3904 11.0178 11.8223 32.7597 11.8223 59.5797C11.8223 86.3997 33.3904 108.142 59.9961 108.142Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1011,
    cy: 59.0401,
    r: 32.1147,
    fill: "#64D949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3564 30.8677C74.2403 32.2819 77.7489 34.4762 80.6934 37.2613L30.9375 65.9878C30.4083 63.7581 30.127 61.4321 30.127 59.0406C30.127 57.2647 30.2829 55.5246 30.5791 53.8335L70.3564 30.8677Z",
    fill: "#D2FF67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9229 42.2359C88.174 47.0288 90.0752 52.8126 90.0752 59.0406C90.0752 60.8153 89.9189 62.5537 89.623 64.2437L49.8418 87.2115C42.511 84.5411 36.5165 79.0912 33.1328 72.1363L84.9229 42.2359Z",
    fill: "#D2FF67"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1016,
    cy: 59.0401,
    r: 23.5508,
    fill: "#52A73E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.1012,
    cy: 59.0401,
    rx: 21.4098,
    ry: 21.4098,
    fill: "#64D949"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1760_6222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 37,
    width: 44,
    height: 44
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.1012,
    cy: 59.0401,
    rx: 21.4098,
    ry: 21.4098,
    fill: "#424657"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1760_6222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.416 94.9016L72.4135 56.3639L59.5676 59.0401L52.6094 70.2803L91.1471 108.818L110.416 94.9016Z",
    fill: "#52A73E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6373 85.8024L60.0996 47.2647V59.0401L98.6373 97.5778V85.8024Z",
    fill: "#52A73E"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1019 47.2647L63.8773 54.9143L72.4126 56.3639L66.2105 62.0954L67.5954 70.2803L60.1019 66.5336L52.6085 70.2803L53.9934 62.0954L47.8848 56.141L56.3266 54.9143L60.1019 47.2647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeKeynote);
export default __webpack_public_path__ + "static/media/badge-keynote.58f2d03a405da2f1cf7f0688314fa29f.svg";
export { ForwardRef as ReactComponent };